import { FormFieldsContainer } from '../../../Form'

import { DayIntro } from './DayIntro'
import { FollowUpsField } from './FollowUpsField'
import { TargetDayField } from './TargetDayField'

function CalendarRelieveDayModalFields({
  day,
  dayLoad,
  followUps,
  isLoading,
  nextFreeDay,
  targetLoad,
}) {
  return (
    <FormFieldsContainer>
      <DayIntro day={day} dayLoad={dayLoad} />
      <FollowUpsField
        dayLoad={dayLoad}
        followUps={followUps}
        isLoading={isLoading}
      />
      <TargetDayField
        day={day}
        isLoading={isLoading}
        nextFreeDay={nextFreeDay}
        targetLoad={targetLoad}
      />
    </FormFieldsContainer>
  )
}

export default CalendarRelieveDayModalFields
